import { render, staticRenderFns } from "./LowAvailableBalanceFooter.vue?vue&type=template&id=0e51016f&"
import script from "./LowAvailableBalanceFooter.vue?vue&type=script&lang=js&"
export * from "./LowAvailableBalanceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
